module.exports = __webpack_public_path__ + "static/media/drum.ce8eccf0.svg";